import { observer } from "mobx-react-lite";
import './FilterButton.scss';
/**
 * @typedef {Object} Props
 * @property {Function} onClick
 * @property {{category: string, label: string, value: string|number}} filter 
 */
const FilterButton = observer(({ onClick, filter }: Props) => {
    return (
        <div className="FilterButton" onClick={() => {
            onClick(filter)
        }}>
            {filter.category ? `${filter.category}: ` : ''}{filter.label}
            <button className="FilterButton__remove" type="button">
                <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 4.5061L4 12.5061M4 4.5061L12 12.5061" stroke="#787878" strokeWidth="0.9" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
            </button>

        </div>
    )
})

FilterButton.displayName = 'FilterButton';

export default FilterButton;